// @flow
import * as React from 'react';

import PageContext from '../index';

export default function usePageContext() {
  return React.useContext(PageContext);
}
